/**
 * NER-4488 fase 2 — Plantillas de reglas de promoción.
 *
 * Cada plantilla precarga el modal "Nueva regla" de PromotionsPage con el
 * shape plano del formulario (ver `src/utils/promoMapper.js`): tipo, días,
 * horario y descuento. `categoryHints` son fragmentos que se buscan en el
 * nombre de las categorías de la carta para preseleccionar a qué aplica; sin
 * pistas, la regla aplica a toda la carta (targets vacíos = todos los items,
 * ver `services/menu/shared/promoEvaluator.js isItemTargeted`).
 *
 * Los textos viven en i18n bajo `promoTemplates.{id}.{name,description}`.
 * Módulo puro: sin React ni services/api.
 */

export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri'];
export const WEEKEND = ['sat', 'sun'];
export const EVERY_DAY = [...WEEKDAYS, ...WEEKEND];

/**
 * @typedef {Object} PromoTemplate
 * @property {string} id
 * @property {string} icon           nombre de icono lucide-react
 * @property {'happy_hour'|'early_bird'|'off_peak'|'flash'} type
 * @property {string[]} days
 * @property {string} start          HH:MM
 * @property {string} end            HH:MM
 * @property {'percentage'|'fixed'} discountType
 * @property {number} discountValue
 * @property {string[]} categoryHints
 */

/** @type {PromoTemplate[]} */
export const PROMO_TEMPLATES = [
  {
    id: 'happy-hour',
    icon: 'Beer',
    type: 'happy_hour',
    days: WEEKDAYS,
    start: '18:00',
    end: '20:00',
    discountType: 'percentage',
    discountValue: 20,
    categoryHints: ['bebida', 'trago', 'cerveza', 'vino', 'cocktail', 'coctel', 'bar', 'drink'],
  },
  {
    id: 'lunch',
    icon: 'Sun',
    type: 'off_peak',
    days: WEEKDAYS,
    start: '12:00',
    end: '15:00',
    discountType: 'percentage',
    discountValue: 15,
    categoryHints: ['principal', 'plato', 'almuerzo', 'ejecutivo', 'menu del dia', 'lunch'],
  },
  {
    id: 'early-bird',
    icon: 'Sunrise',
    type: 'early_bird',
    days: EVERY_DAY,
    start: '19:00',
    end: '20:30',
    discountType: 'percentage',
    discountValue: 10,
    categoryHints: [],
  },
  {
    id: 'afternoon',
    icon: 'Coffee',
    type: 'off_peak',
    days: WEEKDAYS,
    start: '16:00',
    end: '19:00',
    discountType: 'percentage',
    discountValue: 15,
    categoryHints: ['cafe', 'café', 'pasteler', 'merienda', 'dulce', 'torta', 'panader'],
  },
  {
    id: 'weekend-flash',
    icon: 'Zap',
    type: 'flash',
    days: WEEKEND,
    start: '12:00',
    end: '23:59',
    discountType: 'percentage',
    discountValue: 15,
    categoryHints: [],
  },
  {
    id: 'midweek',
    icon: 'CalendarDays',
    type: 'off_peak',
    days: ['tue', 'wed'],
    start: '00:00',
    end: '23:59',
    discountType: 'percentage',
    discountValue: 10,
    categoryHints: [],
  },
];

export function getPromoTemplate(templateId) {
  return PROMO_TEMPLATES.find((tpl) => tpl.id === templateId);
}
